import { Button } from "@jsq/ds/core";
import React from "react";
import { LoginCard } from "../../common/LoginCard";
import { defaultSingleManagerPoweredByMessage } from "../../common/LoginCard/constants";

export type Props = {
  arenaName?: string;
  redirectLocation: string;
};

// We set window.location because we are crossing domain here from GP -> P2.0 and want full reload.
const redirectToPortal = (redirectLocation: string) => {
  window.location.href = redirectLocation;
};

export const LoginStaffUpgradeEmail2FACard: React.FunctionComponent<Props> = ({
  arenaName,
  redirectLocation,
}) => {
  const description =
    "Your account is linked to a portal account that has email configured as the two-factor authentication method. You need to upgrade your two-factor authentication method to text message or authenticator app on your portal in order to sign in.";

  return (
    <LoginCard
      showPoweredByHeader={!!arenaName}
      poweredByHelpMessage={defaultSingleManagerPoweredByMessage(arenaName)}
      showCardTitle
      cardTitle="Upgrade your two-step authentication"
      titleDataTestId="staff-upgrade-email-2fa-text-title"
      description={description}
    >
      <Button
        isFullWidth
        className="align-center stacked-bottom-xl"
        variant="primary"
        onClick={() => redirectToPortal(redirectLocation)}
        data-cy="staff-upgrade-email-2fa-text-button"
      >
        Log into portal
      </Button>
    </LoginCard>
  );
};

export default LoginStaffUpgradeEmail2FACard;
